import { render } from "./TemplateFormat.vue?vue&type=template&id=4a57ae4c"
import script from "./TemplateFormat.vue?vue&type=script&lang=js"
export * from "./TemplateFormat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__